import crowdstrikeLogo from "~/src/assets/integrations/crowdstrike.png";
import crowdstrikeLogoDetail from "~/src/assets/integrations/crowdstrike-detail.png";
import firehydrantLogo from "~/src/assets/integrations/firehydrant.png";
import firehydrantLogoDark from "~/src/assets/integrations/firehydrant-reverse.svg";
import firehydrantLogoDetail from "~/src/assets/integrations/firehydrant-detail.png";
import googleLogo from "~/src/assets/integrations/google/google.png";
import googleSecopsLogo from "~/src/assets/integrations/google/google-secops.svg";
import googleSecopsLogoDark from "~/src/assets/integrations/google/google-secops-reverse.svg";
import googleSecopsLogoDetail from "~/src/assets/integrations/google/google-secops-detail.png";
import jiraLogo from "~/src/assets/integrations/atlassian/jira.svg";
import jiraLogoDark from "~/src/assets/integrations/atlassian/jira-reverse.png";
import jiraLogoDetail from "~/src/assets/integrations/atlassian/jira-detail.svg";
import jiraServiceMgmtLogo from "~/src/assets/integrations/atlassian/jira-service-management.png";
import jiraServiceMgmtLogoDark from "~/src/assets/integrations/atlassian/jira-service-management-reverse.png";
import jiraServiceMgmtLogoDetail from "~/src/assets/integrations/atlassian/jira-service-management-detail.png";
import magnitudeLogo from "~/src/assets/integrations/magnitude-logo.png";
import magnitudeLogoDark from "~/src/assets/integrations/magnitude-logo-dark.png";
import magnitudeDetail from "~/src/assets/integrations/magnitude-detail.png";
import msEntraLogo from "~/src/assets/integrations/microsoft/microsoft-entra.png";
import msEntraLogoDark from "~/src/assets/integrations/microsoft/microsoft-entra-reverse.png";
import microsoftLogoDetail from "~/src/assets/integrations/microsoft/microsoft-detail.png";
import msTeamsLogo from "~/src/assets/integrations/microsoft/microsoft-teams.png";
import oktaLogo from "~/src/assets/integrations/okta.png";
import oktaLogoDark from "~/src/assets/integrations/okta-reverse.png";
import oktaLogoDetail from "~/src/assets/integrations/okta-detail.png";
import oneloginLogo from "~/src/assets/integrations/onelogin.png";
import oneloginLogoDark from "~/src/assets/integrations/onelogin-reverse.png";
import oneloginLogoDetail from "~/src/assets/integrations/onelogin-detail.png";
import opsGenieLogo from "~/src/assets/integrations/atlassian/ops-genie.svg";
import opsGenieLogoDetail from "~/src/assets/integrations/atlassian/ops-genie-detail.svg";
import pagerDutyLogo from "~/src/assets/integrations/pager-duty.svg";
import pagerDutyLogoDetail from "~/src/assets/integrations/pager-duty-detail.png";
import pingLogo from "~/src/assets/integrations/ping.svg";
import pingLogoDark from "~/src/assets/integrations/ping-reverse.svg";
import pingLogoDetail from "~/src/assets/integrations/ping-detail.png";
import paloAltoCortexLogo from "~/src/assets/integrations/palo-alto-cortex-xsoar.png";
import paloAltoCortexLogoDark from "~/src/assets/integrations/palo-alto-cortex-xsoar-reverse.png";
import paloAltoCortexLogoDetail from "~/src/assets/integrations/palo-alto-cortex-xsoar-detail.png";
import revelstokeLogo from "~/src/assets/integrations/revelstoke.png";
import revelstokeLogoDark from "~/src/assets/integrations/revelstoke-reverse.png";
import revelstokeLogoDetail from "~/src/assets/integrations/revelstoke-detail.png";
import salesforceLogo from "~/src/assets/integrations/salesforce.png";
import serviceNowLogo from "~/src/assets/integrations/servicenow.svg";
import serviceNowLogoDark from "~/src/assets/integrations/servicenow-reverse.svg";
import serviceNowLogoDetail from "~/src/assets/integrations/servicenow-detail.svg";
import slackLogo from "~/src/assets/integrations/slack.png";
import slackLogoDark from "~/src/assets/integrations/slack-reverse.png";
import slackLogoDetail from "~/src/assets/integrations/slack-detail.png";
import torqLogo from "~/src/assets/integrations/torq.png";
import torqLogoDark from "~/src/assets/integrations/torq-reverse.png";
import vantaLogo from "~/src/assets/integrations/vanta.png";
import vantaLogoDark from "~/src/assets/integrations/vanta-reverse.png";
import zapierLogo from "~/src/assets/integrations/zapier.png";
import zapierLogoDark from "~/src/assets/integrations/zapier-reverse.png";
import zapierLogoDetail from "~/src/assets/integrations/zapier-detail.svg";
import zoomLogo from "~/src/assets/integrations/zoom.png";
import zoomLogoDetail from "~/src/assets/integrations/zoom-detail.png";

const integrationData = [
  {
    name: "crowdstrike",
    title: "CrowdStrike Falcon",
    category: "Orchestration & Automation",
    logo: crowdstrikeLogo,
    logoDetail: crowdstrikeLogoDetail,
    configuration: {},
  },
  {
    name: "firehydrant",
    title: "FireHydrant",
    category: "Ticketing",
    logo: firehydrantLogo,
    logoDark: firehydrantLogoDark,
    logoDetail: firehydrantLogoDetail,
    configuration: {},
  },
  {
    name: "google",
    title: "Google Workspaces",
    category: "Authentication",
    logo: googleLogo,
    logoDetail: googleLogo,
    configuration: {},
  },
  {
    name: "googlesecops",
    title: "Google SecOps",
    category: "Orchestration & Automation",
    logo: googleSecopsLogo,
    logoDark: googleSecopsLogoDark,
    logoDetail: googleSecopsLogoDetail,
    configuration: {logoMaxWidth: "150px"},
  },
  {
    name: "jira",
    title: "Jira",
    category: "Ticketing",
    logo: jiraLogo,
    logoDark: jiraLogoDark,
    logoDetail: jiraLogoDetail,
    configuration: {},
  },
  {
    name: "jiraservicemanagement",
    title: "Jira Service Management",
    category: "Notification",
    logo: jiraServiceMgmtLogo,
    logoDark: jiraServiceMgmtLogoDark,
    logoDetail: jiraServiceMgmtLogoDetail,
    configuration: {logoMaxWidth: "175px"},
  },
  {
    name: "magnitude",
    title: "Magnitude",
    category: "Third-Party Risk Management",
    logo: magnitudeLogo,
    logoDark: magnitudeLogoDark,
    logoDetail: magnitudeDetail,
    configuration: {logoMaxWidth: "175px"},
  },
  {
    name: "msentra",
    title: "Microsoft Entra ID",
    category: "Authentication",
    logo: msEntraLogo,
    logoDark: msEntraLogoDark,
    logoDetail: microsoftLogoDetail,
    configuration: {},
  },
  {
    name: "msteams",
    title: "Microsoft Teams",
    category: "Notification",
    logo: msTeamsLogo,
    logoDetail: microsoftLogoDetail,
    configuration: {},
    isNew: true,
  },
  // Opened from the "msteams" card. TODO(msteams-v1): when the v1 webhook integration is removed,
  // rename this entry to "msteams", drop `hidden`, and delete the v1 entry above.
  {
    name: "msteamsv2",
    title: "Microsoft Teams",
    category: "Notification",
    hidden: true,
    logo: msTeamsLogo,
    logoDetail: microsoftLogoDetail,
    configuration: {},
  },
  {
    name: "okta",
    title: "Okta",
    category: "Authentication",
    logo: oktaLogo,
    logoDark: oktaLogoDark,
    logoDetail: oktaLogoDetail,
    configuration: {},
  },
  {
    name: "onelogin",
    title: "OneLogin",
    category: "Authentication",
    logo: oneloginLogo,
    logoDark: oneloginLogoDark,
    logoDetail: oneloginLogoDetail,
    configuration: {},
  },
  {
    name: "opsgenie",
    title: "Opsgenie",
    category: "Notification",
    logo: opsGenieLogo,
    logoDetail: opsGenieLogoDetail,
    configuration: {},
  },
  {
    name: "pagerduty",
    title: "PagerDuty",
    category: "Notification",
    logo: pagerDutyLogo,
    logoDetail: pagerDutyLogoDetail,
    configuration: {},
  },
  {
    name: "ping",
    title: "Ping",
    category: "Authentication",
    logo: pingLogo,
    logoDark: pingLogoDark,
    logoDetail: pingLogoDetail,
    configuration: {},
  },
  {
    name: "xsoar",
    title: "Palo Alto Cortex XSOAR",
    category: "Orchestration & Automation",
    logo: paloAltoCortexLogo,
    logoDark: paloAltoCortexLogoDark,
    logoDetail: paloAltoCortexLogoDetail,
    configuration: {},
  },
  {
    name: "revelstoke",
    title: "Revelstoke",
    category: "Orchestration & Automation",
    logo: revelstokeLogo,
    logoDark: revelstokeLogoDark,
    logoDetail: revelstokeLogoDetail,
    configuration: {},
  },
  {
    name: "salesforce",
    title: "Salesforce",
    category: "CRM",
    logo: salesforceLogo,
    logoDetail: salesforceLogo,
    configuration: {},
  },
  {
    name: "servicenow",
    title: "ServiceNow",
    category: "Ticketing",
    logo: serviceNowLogo,
    logoDetail: serviceNowLogoDetail,
    logoDark: serviceNowLogoDark,
    configuration: {},
  },
  {
    name: "slack",
    title: "Slack",
    category: "Notification",
    logo: slackLogo,
    logoDark: slackLogoDark,
    logoDetail: slackLogoDetail,
    configuration: {},
    isNew: true,
  },
  {
    name: "torq",
    title: "Torq",
    category: "AI SOC",
    logo: torqLogo,
    logoDark: torqLogoDark,
    logoDetail: torqLogo,
    logoDetailDark: torqLogoDark,
    configuration: {},
  },
  {
    name: "slackV2",
    title: "Slack",
    category: "Notification",
    hidden: true,
    logo: slackLogo,
    logoDark: slackLogoDark,
    logoDetail: slackLogoDetail,
    configuration: {},
  },
  {
    name: "vanta",
    title: "Vanta",
    category: "Compliance",
    logo: vantaLogo,
    logoDark: vantaLogoDark,
    logoDetail: null, // VantaDetailIcon inline
    configuration: {},
  },
  {
    name: "zapier",
    title: "Zapier",
    category: "Orchestration & Automation",
    logo: zapierLogo,
    logoDark: zapierLogoDark,
    logoDetail: zapierLogoDetail,
    configuration: {},
  },
  {
    name: "zoom",
    title: "Zoom",
    category: "Communication",
    logo: zoomLogo,
    logoDetail: zoomLogoDetail,
    configuration: {},
  },
  // place generic integrations last
  {
    name: "genericsaml",
    title: "SAML Connector",
    category: "Authentication",
    logo: "GENERICSAML",
    logoDetail: null,
    configuration: {},
  },
];

const integrationCategoryInfo = {
  "AI SOC": "Open incidents in BreachRx from AI Security Operation platforms.",
  Authentication: "Use Single Sign-On (SSO) with the BreachRx platform.",
  CRM: "Use your CRM system to automatically create contract procedures in BreachRx.",
  Communication: "Use communication platforms from within BreachRx.",
  Compliance: "Integrate BreachRx with access review and compliance solutions.",
  Notification: "Use external ticketing and ITSM platforms to deliver BreachRx notifications.",
  "Orchestration & Automation":

    "Automatically open cases in BreachRx from security automation, orchestration, and alerting platforms.",
  "Third-Party Risk Management":
    "Open incidents in BreachRx from third-party risk management platforms.",
  Ticketing: "Open tickets in BreachRx from external ticketing and ITSM applications.",
  Utility:

    "Use utility platforms to automatically take action when certain events happen in the BreachRx platform.",
};

export {integrationData, integrationCategoryInfo};
